import React from "react";
import HexRatingReviews from "../../../../components/HexRatingReviews";

import "./style.css";

const SupplierRating = ({
  rating,
  totalRatings,
  className,
  reviewText,
  onClick,
  outOf,
  hideTextRating,
  decimalRating
}) => {
  return (
    <HexRatingReviews
      rating={rating}
      totalRatings={totalRatings}
      className={`supplier-rating ${className || ""}`}
      reviewText={reviewText || ""}
      onClick={onClick}
      outOf={outOf}
      hideTextRating={hideTextRating}
      decimalRating={decimalRating}
    />
  );
};

export default SupplierRating;
